// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-check:checked ~ .input-check__circle[data-v-86464d92] {\n  display: none;\n}\n.input-check:not(:checked) ~ .input-check__checked[data-v-86464d92] {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
